import React, { useCallback, useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "../../../assets/dataTable.css";
import { Link, useLocation} from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { 
    reqGET, 
    reqDELETE,
    set_language,
	content_language, 
} from '../../../Utils';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import { language } from '../../WEBContent/Language';

//import Hosts from '../../Hosts';

export default function List() {

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const { pathname } = useLocation();

    const [, set_SIDE_BAR] = useState([])
    const [permissions, set_permissions] = useState({})

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    let fetchApi = useCallback( () => {

        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                //console.log(res.data)
                res.data.forEach((v) => {
                    if(v.info.cfp !== undefined) {
                        v.info.cfp.forEach((v2) => {
                            v2.data_inicio.forEach((v_2) => {
                            //console.log('Array DATA INICIO: ', v_2);

                            if(v_2.estado === 'activo') {
                                //console.log('data inicio: ', v_2.data);
                                v2.data_inicio_activo = v_2.data;
                            }
                            })
                            v2.data_submissao.forEach((v_3) => {
                                if(v_3.estado === 'activo') {
                                    v2.data_submissao_activo = v_3.data;
                                }
                            })
                            v2.data_limite_fim.forEach((v_4) => {
                                if(v_4.estado === 'activo') {
                                    v2.data_limite_fim_activo = v_4.data;
                                }
                            })
                        })
                    }
                })
                setData(res.data);

                UseSidebar().getSidebar(getTokenInfo().profile)
                    .then(v => {
                        //console.log('V ' + v);
                        get_permissions(pathname, v)
                        set_SIDE_BAR(v)
                        // RC        setLoading(false)
                    }/* set_SIDE_BAR(v) */);
            })
            .catch(() => 404
                //  TODO: ENVIAR PÝGINA 404
                //alert(error)); 
            )
    }, [pathname])

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;
            //console.log('PathName', name)
            //console.log('SIDEBAR', sidebar)

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {
                    node.submenu.forEach(subitem => {
                        if (subitem.path === name) {
                            //console.log('NO SUBITEM ', name)
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove });
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            //console.log(sidebar)
            sidebar.forEach(node => {
                //console.log('Node ', node)
                if(node.path === name && 0) {
                    //console.log('NO ITEM ', node.path)
                    //console.log(node)
                    //console.log('NODE EDIT ' + node.edit)
                    //console.log('NODE REMOVE ' + node.remove)
                    set_permissions({ edit: node.edit, view: true, remove: node.remove });
                    //console.log('no true')
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {
        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }
        //console.log('PathName', pathname)
        fetchApi();
    }, [fetchApi, pathname]);

    //APAGAR REGISTO
    function apagar(id) {
        if (window.confirm(language[lang].delete_event)) {
            reqDELETE(api_crud_route, { id: id })
                .then(() => {
                    setLoading(true);
                    alert(language[lang].delete_success);
                })
                .then(() => fetchApi())
                .catch(e => alert(language[lang].delete_error))
        }
    }

    const columns = [
        {
            name: language[lang].name,
            selector: 'info.name',
            sortable: true,
            left: true,
        },    
        {
            name: language[lang].event_type,
            selector: 'info.tipo',            
            sortable: true,
            left: true,
        },    
        /* {
            name: 'Data de Inicio',
            selector: 'info.cfp[0].data_inicio_activo',            
            sortable: true,
            left: true,
        },
        {
            name: 'Data de Fim',
            selector: 'info.cfp[0].data_final_processo',            
            sortable: true,
            left: true,
        }, */
        {
            name: '',
            right: true,
            export: false,
            print: false,
            cell: row =>
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <img alt={ language[ lang ].view } src={'./img/view.svg'} />
                        <span className="tooltiptext">{language[lang].view}</span>
                    </Link>
                    <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} replace>
                        <img alt={ language[ lang ].edit } src={'./img/editar.svg'} />
                        <span className="tooltiptext">{language[lang].edit}</span>
                    </Link>
                    <button onClick={() => apagar(row['id'])} className={permissions.remove ? "button btn-delete" : "d-none" }>
                        <img alt={ language[ lang ].delete } src={'./img/eliminar.svg'} />
                        <span className="tooltiptext">{language[lang].delete}</span>
                    </button>
                </span >
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].search
    };

    return (isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">LOADING</h2>
                <p>{ language[ lang ].loading }</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>

            </div>
        </main>

        :

        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language[lang].events}</h2>
                <p>{language[lang].home} / {language[lang].events} / {language[lang].events_list}</p>
            </div>

            <div className={`dash-cards-2 body`}>
                <div className="card">
                    <div className="div-table">
                        <div className="table-body">
                            <DataTableExtensions {...tableData}>

                                <DataTable
                                    noDataComponent={language[lang].no_results}
                                    noHeader
                                    pagination
                                    exportHeaders
                                    paginationComponentOptions={defaultComponentOptions}
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}